
<div class="p-4">
  <div class="font-weight-bold">Add vendor for selected parts</div>
  <ValidationObserver tag="form" ref="form" @submit.stop.prevent="addVendor" v-slot="{ invalid }" class="">
    <div class="row">
      <div class="col-12">
        <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
          <div class="label mt-2">Name</div>
          <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" placeholder="Name of the vendor" v-model="vendor.name" />
        </ValidationProvider>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ValidationProvider name="Email" rules="email" v-slot="{ errors }">
          <div class="label mt-2">E-Mail</div>
          <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" placeholder="E-Mail address of the vendor (optional)" v-model="vendor.email" />
        </ValidationProvider>
      </div>
    </div>

    <hr />

    <div class="mt-3 d-flex justify-content-between align-content-center">
      <div class="so-btn">
        <button type="button" class="btn btn-block btn-sm btn-secondary" @click="cancel()">
          <i class="far fa-times"></i>
          Cancel
        </button>
      </div>
      <div class="so-btn">
        <button type="submit" class="btn btn-block btn-sm btn-success" :disabled="invalid">
          <i class="far fa-plus"></i>
          Add vendor
        </button>
      </div>
    </div>
  </ValidationObserver>
</div>
